import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiMail, FiPhone, FiCalendar, FiUsers } from 'react-icons/fi';
import { getPublicDerasars } from '../../services/api';
import styles from './LandingLayout.module.css';

const slugify = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const buildAddress = (p) => {
  if (!p) return null;
  const lines = [
    [p.flatNo, p.buildingName].filter(Boolean).join(', '),
    p.addressLine1,
    p.addressLine2,
    [p.city, p.state, p.pincode].filter(Boolean).join(', '),
    p.country && p.country !== 'India' ? p.country : '',
  ].filter(Boolean);
  return lines.length ? lines.join(', ') : null;
};

const DerasarsPage = () => {
  const [derasars, setDerasars] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    getPublicDerasars()
      .then(res => setDerasars(res.data))
      .catch(() => setDerasars([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <div className={styles.sectionLabel}>Our Network</div>
        <h2 className={styles.sectionTitle}>Derasars on This Platform</h2>
        <p className={styles.sectionLead}>
          The following Jain temples are actively using JainamSevaSetu.
          Click on any Derasar to learn more about it.
        </p>

        {loading ? (
          <div className={styles.loader}><div className={styles.spinner} /></div>
        ) : derasars.length === 0 ? (
          <p className={styles.emptyMsg}>No Derasars registered yet. Be the first to register yours.</p>
        ) : (
          <div className={styles.derasarGrid}>
            {derasars.map(d => (
              <Link
                key={d.id}
                to={`/derasars/${d.id}/${slugify(d.name)}`}
                className={styles.derasarCard}
              >
                <div className={styles.derasarAvatar}>{d.name.charAt(0).toUpperCase()}</div>
                <div className={styles.derasarBody}>
                  <h3 className={styles.derasarName}>{d.name}</h3>
                  {d.description && <p className={styles.derasarDesc}>{d.description}</p>}
                  <div className={styles.derasarMeta}>
                    {(buildAddress(d.adminProfile) || d.city) && (
                      <span className={styles.metaItem}>
                        <FiMapPin size={13} />
                        {buildAddress(d.adminProfile) || [d.city, d.state].filter(Boolean).join(', ')}
                      </span>
                    )}
                    {d.contactEmail && (
                      <span className={styles.metaItem}><FiMail size={13} />{d.contactEmail}</span>
                    )}
                    {d.contactPhone && (
                      <span className={styles.metaItem}><FiPhone size={13} />{d.contactPhone}</span>
                    )}
                    {d.establishDate && (
                      <span className={styles.metaItem}>
                        <FiCalendar size={13} />Est. {new Date(d.establishDate).getFullYear()}
                      </span>
                    )}
                    {d.personCount > 0 && (
                      <span className={styles.metaItem}>
                        <FiUsers size={13} />{d.personCount} person{d.personCount !== 1 ? 's' : ''}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default DerasarsPage;
